import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from 'common/components/Button';
import { DEFAULT_PAPER_ELEVATION } from 'common/constants';
import { utils } from 'styles';

type Props = {
    setCheckoutValues: Function;
};

const genericStyles = {
    textDecoration: 'none',
};

const EmptyCart: React.FC<Props> = ({ setCheckoutValues }) => {
    useEffect(() => {
        setCheckoutValues(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const noUnderline = utils.makeGenericStyles(genericStyles);

    return (
        <Grid container>
            <Grid item xs={12}>
                <Paper elevation={DEFAULT_PAPER_ELEVATION} square>
                    <Box p={4}>
                        <Typography>Twój koszyk jest pusty!</Typography>
                    </Box>
                </Paper>
                <Box mt={4}>
                    <Link to="/products"
                          className={noUnderline.root}>
                        <Button>Wróć do zakupów</Button>
                    </Link>
                </Box>
            </Grid>
        </Grid>
    );
};

export default EmptyCart;
